const en = {
  title: 'Equipment',
  subtitle: 'Manage your equipment inventory',
  report: 'Report',
  templatesCount: 'Templates ({{count}})',
  createEquipment: '+ Create Equipment',
  totalEquipment: 'Total Equipment',
  createdThisWeek: 'Created This Week',
  createdThisMonth: 'Created This Month',
  createdThisYear: 'Created This Year',
  filteredResults: 'Filtered Results',
  searchingFor: 'Searching for:',
  allWeeks: 'All Weeks',
  allMonths: 'All Months',
  allYears: 'All Years',
  thisWeek: 'This Week',
  lastWeek: 'Last Week',
  week: 'Week {{number}}',
  clear: 'Clear',
  noEquipmentYet: 'No Equipment Yet',
  createFirstEquipment: 'Create your first equipment',
  equipmentTemplates: 'Equipment Templates',
  noTemplatesSaved: 'No templates saved yet.',
  partsCount: '{{count}} parts',
  use: 'Use',
  saveAsTemplateTitle: 'Save as Template',
  templateNamePlaceholder: 'Template name',
  createEquipmentModalTitle: 'Create Equipment',
  model: 'Model',
  serialNumber: 'Serial Number',
  quantity: 'Quantity',
  serialNumbers: 'Serial Numbers',
  serialNumberOptional: 'Serial number (optional)',
  addSerialNumber: 'Add another unit',
  confirmMissingSerials: 'You are creating {{count}} items, {{missing}} of them without a serial number. Continue?',
  removeSerialNumber: 'Remove serial number',
  createMultiple: 'Create {{count}} items',
  brand: 'Brand',
  category: 'Category',
  articleId: 'Article ID',
  productionDate: 'Production Date',
  partsWithCount: 'Parts ({{count}})',
  saveAsTemplateCheckbox: 'Save as template',
  createFromTemplate: 'Create from Template',
  createWithPartsCount: 'Create ({{count}} parts)',
  equipmentDetailsTitle: 'Equipment Details',
  serial: 'Serial',
  template: 'Template',
  created: 'Created',
  partsUsed: 'Parts Used',
  saveAsTemplate: '💾 Save as Template',
  months: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  },
  confirmDeleteEquipment: 'Are you sure you want to delete this equipment? The parts and components used to build it will be returned to stock.',
  confirmDeleteTemplate: 'Delete template "{{name}}"?',
  selectTemplateOrAddPart: 'Please select a template or add at least one part',
  enterTemplateName: 'Please enter a template name',
  templateSaved: 'Template "{{name}}" saved!',
  failedToCreateEquipment: 'Failed to create equipment: {{message}}',
  erpBookingFailed:
    'WARNING: The equipment was created, but booking it in the ERP FAILED: {{error}}{{doc}}\nPlease book this production in the ERP manually.',
  failedToUpdate: 'Failed to update: {{message}}',
  failedToDelete: 'Failed to delete: {{message}}',
  failedToSaveTemplate: 'Failed to save template: {{message}}',
  failedToDeleteTemplate: 'Failed to delete template: {{message}}',
};

const de = {
  title: 'Ausrüstung',
  subtitle: 'Verwalten Sie Ihren Ausrüstungsbestand',
  report: 'Bericht',
  templatesCount: 'Vorlagen ({{count}})',
  createEquipment: '+ Ausrüstung erstellen',
  totalEquipment: 'Ausrüstung gesamt',
  createdThisWeek: 'Diese Woche erstellt',
  createdThisMonth: 'Diesen Monat erstellt',
  createdThisYear: 'Dieses Jahr erstellt',
  filteredResults: 'Gefilterte Ergebnisse',
  searchingFor: 'Suche nach:',
  allWeeks: 'Alle Wochen',
  allMonths: 'Alle Monate',
  allYears: 'Alle Jahre',
  thisWeek: 'Diese Woche',
  lastWeek: 'Letzte Woche',
  week: 'Woche {{number}}',
  clear: 'Zurücksetzen',
  noEquipmentYet: 'Noch keine Ausrüstung',
  createFirstEquipment: 'Erstellen Sie Ihre erste Ausrüstung',
  equipmentTemplates: 'Ausrüstungsvorlagen',
  noTemplatesSaved: 'Noch keine Vorlagen gespeichert.',
  partsCount: '{{count}} Teile',
  use: 'Verwenden',
  saveAsTemplateTitle: 'Als Vorlage speichern',
  templateNamePlaceholder: 'Vorlagenname',
  createEquipmentModalTitle: 'Ausrüstung erstellen',
  model: 'Modell',
  serialNumber: 'Seriennummer',
  quantity: 'Menge',
  serialNumbers: 'Seriennummern',
  serialNumberOptional: 'Seriennummer (optional)',
  addSerialNumber: 'Weiteres Gerät hinzufügen',
  confirmMissingSerials: 'Es werden {{count}} Artikel erstellt, davon {{missing}} ohne Seriennummer. Fortfahren?',
  removeSerialNumber: 'Seriennummer entfernen',
  createMultiple: '{{count}} Artikel erstellen',
  brand: 'Marke',
  category: 'Kategorie',
  articleId: 'Artikel-ID',
  productionDate: 'Produktionsdatum',
  partsWithCount: 'Teile ({{count}})',
  saveAsTemplateCheckbox: 'Als Vorlage speichern',
  createFromTemplate: 'Aus Vorlage erstellen',
  createWithPartsCount: 'Erstellen ({{count}} Teile)',
  equipmentDetailsTitle: 'Ausrüstungsdetails',
  serial: 'Seriennummer',
  template: 'Vorlage',
  created: 'Erstellt',
  partsUsed: 'Verwendete Teile',
  saveAsTemplate: '💾 Als Vorlage speichern',
  months: {
    1: 'Januar',
    2: 'Februar',
    3: 'März',
    4: 'April',
    5: 'Mai',
    6: 'Juni',
    7: 'Juli',
    8: 'August',
    9: 'September',
    10: 'Oktober',
    11: 'November',
    12: 'Dezember',
  },
  confirmDeleteEquipment: 'Möchten Sie diese Ausrüstung wirklich löschen? Die dafür verwendeten Teile und Komponenten werden wieder ins Lager gebucht.',
  confirmDeleteTemplate: 'Vorlage "{{name}}" löschen?',
  selectTemplateOrAddPart:
    'Bitte wählen Sie eine Vorlage oder fügen Sie mindestens ein Teil hinzu',
  enterTemplateName: 'Bitte geben Sie einen Vorlagennamen ein',
  templateSaved: 'Vorlage "{{name}}" gespeichert!',
  failedToCreateEquipment:
    'Ausrüstung konnte nicht erstellt werden: {{message}}',
  erpBookingFailed:
    'ACHTUNG: Die Ausrüstung wurde erstellt, aber die Buchung im ERP ist FEHLGESCHLAGEN: {{error}}{{doc}}\nBitte diese Produktion manuell im ERP buchen.',
  failedToUpdate: 'Aktualisierung fehlgeschlagen: {{message}}',
  failedToDelete: 'Löschen fehlgeschlagen: {{message}}',
  failedToSaveTemplate: 'Vorlage konnte nicht gespeichert werden: {{message}}',
  failedToDeleteTemplate:
    'Vorlage konnte nicht gelöscht werden: {{message}}',
};

const equipment = { en, de };
export default equipment;
